/** Marks a message the Prisma bot wrote, so its replies never read as a person's. */
export const BotIcon = () => (
  <svg viewBox="0 0 16 16" className="h-3.5 w-3.5 text-info" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" aria-hidden>
    <rect x="2.5" y="5" width="11" height="8" rx="2" />
    <path d="M8 5V2.5M6 9h.01M10 9h.01M1 8.5v2M15 8.5v2" />
  </svg>
);
